<app-data-table [columns]="columns" [data]="servicesDataTable()" [filters]="filters" [totalRecords]="totalRecords()"
  [cardTemplate]="card" (add)="onAdd()" (edit)="onEdit($event)" (pageChange)="onPage($event)"
  (removeSelected)="onRemoveSelected($event)" [loading]="loading()" (search)="onSearch($event)" />

<ng-template #card let-service>
  <div class="surface-card shadow-2 p-3 border-round h-full flex flex-column">
    <div class="flex align-items-center justify-content-between mb-3">
      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center bg-indigo-100 text-indigo-500 border-circle w-3rem h-3rem font-bold text-xl mr-2">
          <i class="pi pi-cog"></i>
        </div>
        <div>
          <div class="font-bold text-900 border-round overflow-hidden text-overflow-ellipsis white-space-nowrap"
            style="max-width: 150px;">
            {{ service.address || 'Sin dirección' }}
          </div>
          <div class="text-500 text-sm">{{ service.createAt }}</div>
        </div>
      </div>
      <p-button icon="pi pi-ellipsis-v" [text]="true" [rounded]="true" severity="secondary"
        (onClick)="onEdit(service)"></p-button>
    </div>

    <div class="flex flex-column gap-2 mb-3">
      <div class="flex align-items-center gap-2">
        <span class="p-tag p-tag-info p-tag-rounded text-xs">ID: {{ service.id }}</span>
        <span
          [class]="'p-tag p-tag-rounded text-xs ' + (service.status === 'Pendiente' ? 'p-tag-warning' : (service.status === 'Completado' ? 'p-tag-success' : 'p-tag-info'))">
          {{ service.status }}
        </span>
      </div>
    </div>

    <div class="flex flex-column gap-2 mt-auto">
      <div class="flex align-items-center gap-2 text-700">
        <i class="pi pi-calendar text-500"></i>
        <span>Fin: {{ service.finishAt || 'Pendiente' }}</span>
      </div>
    </div>

    <div class="flex gap-2 mt-3 pt-3 border-top-1 surface-border">
      <p-button label="Ver Detalles" icon="pi pi-eye" class="w-full" [outlined]="true" size="small"
        (onClick)="onEdit(service)" />
    </div>
  </div>
</ng-template>

<app-add-service [(visible)]="dialogVisible" (save)="onSave($event)" />